<template>
  <div class="detail_notice_wrap">
    <div class="detail_notice_title">
      <span> {{$t('notice')}} </span>
    </div>
    <div class="detail_notice_content">
      <div class="dn_header">
        <div class="dn_1">{{ boardData.created_at }} / {{$t('admin_write')}} </div>
        <div class="dn_2">{{ boardData.wr_subject }} </div>

      </div>
      <div class="dn_content ql-editor" v-html="replaceBr(boardData.wr_content)"></div>
    </div>
    <div class="detail_btn" @click="backList()">
      <button>{{$t('list_view')}}</button>
    </div>
    <div style="clear: both"></div>
  </div>
</template>


<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

export default {
  name: "BoardDetailNoticeLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    boardData: {
      type: Object,
      default: () => {
        return []
      }
    },
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    backList(){
      this.$router.back();
    },
    replaceBr(content) {
      if (util.isEmpty(content)) {
        return '';
      }
      return content.replace(/(\n|\r\n)/g, '<br>');
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
